import { useSearchParams } from "react-router-dom";
import { RenderHtml } from "features/jobs/components/RenderHtml";
import { useSaveTalentFeedback } from "../hooks/usSaveTalentFeedback";

const TalentFeedback = () => {
  const [searchParams] = useSearchParams();

  const token = searchParams.get("token") || "";
  const decision = searchParams.get("decision") || "";

  const { data, isLoading, isError } = useSaveTalentFeedback({
    token,
    decision
  });

  if (!token || !decision) {
    return (
      <RenderHtml
        html={`
          <div style="text-align:center;padding:50px;">
            <h1>Invalid Link</h1>
            <p>Required parameters are missing.</p>
          </div>
        `}
      />
    );
  }

  if (isLoading) {
    return (
      <div style={{ textAlign: "center", padding: "50px" }}>
        <p>Processing your request...</p>
      </div>
    );
  }

  if (isError) {
    return (
      <RenderHtml
        html={`
          <div style="text-align:center;padding:50px;">
            <h1>Something went wrong</h1>
            <p>Please try again later.</p>
          </div>
        `}
      />
    );
  }

  return <RenderHtml html={data} />;
};

export default TalentFeedback;
